export default __webpack_public_path__ + "static/media/bgimage.df2d3cc2.png";